import { useJobillaOrgId } from '@/hooks'
import { logger } from '@/ui'
import { Tooltip } from '@/ui/rapid-ui/tooltip'
import { useGetSubscriptionCenterLink } from '@jobilla/nexus-sdk'
import { AlertTriangleIcon, SettingsIcon } from 'lucide-react'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export function NotificationSettingsButton() {
	const { t } = useTranslation('common')
	const organisationId = useJobillaOrgId()

	const {
		data: subscriptionCenterData,
		isFetching: isLoadingSubscriptionLink,
		isError: subscriptionSettingsError,
	} = useGetSubscriptionCenterLink({
		enabled: Boolean(organisationId),
		// Link expires in 1 hour
		refetchInterval: 50 * 60 * 1000,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		refetchOnMount: false,
		retry: false,
	})

	const handleOpen = useCallback(() => {
		if (subscriptionCenterData?.url) {
			window.open(subscriptionCenterData.url, '_blank', 'noopener,noreferrer')
		} else {
			logger.error('NotificationSettingsButton: no URL available', {})
		}
	}, [subscriptionCenterData?.url])

	return (
		<Tooltip
			wrapperClassName="flex items-center"
			content={subscriptionSettingsError
				? t('notifications.subscriptionSettingsError')
				: t('notifications.subscriptionSettings')}
		>
			<button
				type="button"
				onClick={handleOpen}
				disabled={isLoadingSubscriptionLink || Boolean(subscriptionSettingsError)}
				className="cursor-pointer disabled:cursor-not-allowed"
				aria-label={t('notifications.subscriptionSettings')}
			>
				{subscriptionSettingsError
					? <AlertTriangleIcon className="size-4 text-amber-500" />
					: (
						<SettingsIcon
							className={`size-4 text-gray-400 hover:text-gray-600 ${
								isLoadingSubscriptionLink ? 'animate-spin' : ''
							}`}
						/>
					)}
			</button>
		</Tooltip>
	)
}
